export default __webpack_public_path__ + "static/media/ab-test-dark-old.7e364cb2.svg";